import React, { useEffect } from 'react';
import { Box, Typography } from '@material-ui/core';
import { Cancel } from '@material-ui/icons';
import { makeStyles } from '@material-ui/core/styles';
import _ from 'lodash';

const useStyles = makeStyles(() => ({
    block: {
        display: 'flex',
        alignItems: 'flex-start',
        gap: 12,
        background: '#fff3f3',
        border: '1px solid #f44336',
        borderRadius: 6,
        padding: 16,
        marginTop: 8,
    },
    icon: { color: '#f44336', marginTop: 2, flexShrink: 0 },
    field: { fontWeight: 'bold' },
    hint: { color: '#555', marginTop: 8, fontSize: 13 },
}));

export default function IosPrereqStep({ store, isFinished }) {
    const classes = useStyles();

    const teamID = _.get(store, 'platforms.ios.teamID');
    const teamName = _.get(store, 'platforms.ios.teamName');

    const missing = [];
    if (!teamID) missing.push({ label: 'Team ID', key: 'platforms.ios.teamID' });
    if (!teamName) missing.push({ label: 'Nome da empresa (Team Name)', key: 'platforms.ios.teamName' });

    useEffect(() => {
        isFinished(missing.length === 0);
    }, [store]);

    if (missing.length === 0) return null;

    return (
        <Box mt={1}>
            <Typography variant="body2" style={{ marginBottom: 12 }}>
                Antes de configurar dispositivos e credenciais iOS, os campos abaixo precisam estar preenchidos
                na loja. Preencha-os em <strong>Dados de publicação</strong> e reabra este wizard.
            </Typography>

            {missing.map((f) => (
                <div key={f.key} className={classes.block}>
                    <Cancel className={classes.icon} fontSize="small" />
                    <div>
                        <Typography variant="body2" className={classes.field}>{f.label}</Typography>
                        <Typography variant="body2" style={{ color: '#888', fontSize: 12 }}>{f.key}</Typography>
                    </div>
                </div>
            ))}

            <Typography variant="body2" className={classes.hint}>
                O Team ID e o Team Name constam no Apple Developer Portal → Membership Details.
            </Typography>
        </Box>
    );
}
